import { BRAND } from '../data/brand';
import { todayIso } from './format';

export type Row = Record<string, string | number | boolean | null | undefined>;

function csvCell(v: Row[string]): string {
  if (v == null) return '';
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows: Row[]): string {
  if (rows.length === 0) return '';
  const headers = Object.keys(rows[0]);
  return [headers.join(','), ...rows.map((r) => headers.map((h) => csvCell(r[h])).join(','))].join('\n');
}

export function downloadFile(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function datasetFilename(name: string, ext: 'csv' | 'json'): string {
  return `${BRAND.domain.replace('.com', '')}-${name}-${todayIso()}.${ext}`;
}
